// extracted by mini-css-extract-plugin
module.exports = {"main":"about-module--main--1nFcU","image":"about-module--image--30W-N","info":"about-module--info--wSNk2","social":"about-module--social--3VtMf"};